import * as S from "@styles/components/TableViewStyle";
import CTable from "@components/Common/CTable/CTable";
import { TableColumnTypes } from "@typedef/components/Common/CTable/table.column.types";
import { MakerTypes } from "@typedef/components/Device/Maker/maker.types";

type Props = {
  columns: TableColumnTypes<MakerTypes>[];
  tableData: MakerTypes[];
  insertMaker: () => void;
  updateMaker: (idx?: number) => void;
  deleteMaker: () => Promise<void>;
};

const DeviceMaker = ({
  columns,
  tableData,
  insertMaker,
  updateMaker,
  deleteMaker,
}: Props) => {
  return (
    <S.Main>
      <S.TopBtns>
        <h3>전체 {tableData.length}</h3>

        <S.Btns>
          <S.Btn type="button" onClick={insertMaker} className="active">
            제조사등록
          </S.Btn>
          <S.Btn type="button" onClick={() => updateMaker()}>
            수정
          </S.Btn>
          <S.Btn type="button" onClick={deleteMaker}>
            삭제
          </S.Btn>
        </S.Btns>
      </S.TopBtns>
      <CTable columns={columns} tableData={tableData} />
    </S.Main>
  );
};

export default DeviceMaker;
